import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getInvoice } from 'api/Public';

export const useInvoice = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();
  return useQuery(['invoice', ...dependencies], () => getInvoice(navigate, params), {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    ...options
  });
};
